module.exports = __webpack_public_path__ + "img/head-banner.9773b13a.png";